<template>
  <v-card class="card" color="primary">
    <v-card-title class="font-weight-bold justify-center"> Resultados C3</v-card-title>
    <v-card-text>
      <v-container v-if="personal">
        <v-row>
          <v-col lg="8">
            <div class="text-h6 font-weight-bold">Información C3</div>
          </v-col>
          <v-col lg="4">
            <v-row>
              <v-col cols="12">
                <BaseInput v-model="personal.examenC3Mes" label="Exámen C3 mes" readonly></BaseInput>
                <BaseInput v-model="personal.vigenciaAnio" label="Vigencia año" readonly></BaseInput>
                <v-textarea
                  v-model="personal.observacionesC3"
                  rounded
                  filled
                  dense
                  background-color="primary"
                  color="secondary"
                  label="Observaciones C3"
                  no-resize
                  rows="6"
                  readonly
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else>
        <v-row>
          <v-col cols="12" align="center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseInput from '../../../base/BaseInput.vue'

export default {
  components: {
    BaseInput,
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    ...mapGetters({
      perfil: 'getPerfil',
    }),
  },
}
</script>

<style scoped>
/* Textarea dinámico */
::v-deep .v-textarea.v-input--is-focused .v-input__control .v-input__slot::after {
  border-color: var(--v-secondary-base) !important;
}

::v-deep .v-textarea .v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

::v-deep .v-textarea.v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-textarea textarea {
  caret-color: var(--v-secondary-base) !important;
}

/* Cards con efectos modernos */
.card {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.1);
  transition: all 0.3s ease;
}
</style>
